const Map = () => {
  return (
    <div>
      <div className="text-center">
        <h1 className="mx-auto sub-heading">Contact Us</h1>
        <h1 className="heading">- - -</h1>
      </div>
      {/* <img
        src="/images/google-map3.jpg"
        alt=""
        className="w-full h-[200px] object-cover"
      /> */}
    </div>
  );
};

export default Map;
